import * as Types from './types'

export const RASA_ADMIN_ROLE = 'admin'

export const ADMIN_ROLE = 'community_admin'
export const API_ROLE = 'api'
export const MEMBER_ROLE = 'member'
export const REPORTS_ROLE = 'reports'
export const CONTENT_ROLE = 'content'
export const BETA_ROLE = 'beta'
export const INTEGRATIONS_ADMIN_ROLE = 'integrations_admin'

export const hasRole = (user: Types.User, roleName: string): boolean =>
  user.roles.filter((userRoleName) => userRoleName === roleName).length > 0 ||
  user.roles.filter((userRoleName) => userRoleName === RASA_ADMIN_ROLE).length > 0

export const isRasaAdmin = (user: Types.User): boolean => hasRole(user, RASA_ADMIN_ROLE)

export const isRasaSuperAdmin = (user: Types.User): boolean =>
  isRasaAdmin(user) && user.email_address === 'paul.christmann@rasa.io'

export const isBetaUser = (user: Types.User): boolean => hasRole(user, BETA_ROLE)
// return false
export const isIntegrationsAdmin = (user: Types.User): boolean => false && hasRole(user, INTEGRATIONS_ADMIN_ROLE)



// WEBPACK FOOTER //
// ./src/components/user/roles.ts